/**
 * Convex client — the single module-singleton reactive client.
 *
 * Authentication is owned entirely by `ConvexAuthProvider`
 * (`@convex-dev/auth/react`), mounted in `main.tsx` around this client. The
 * former Payload-JWT cookie sync was removed when Payload CMS was retired
 * (the `api.mediatiquepress.one` host is dead and the sync never ran); Convex
 * Auth is now the sole authentication source.
 *
 * The single-instance / module-singleton property is load-bearing: exactly
 * one reactive client exists for the whole app.
 */
import { ConvexReactClient } from 'convex/react';
import { env } from './env';

export const convex = new ConvexReactClient(env.CONVEX_URL);
